import { render, staticRenderFns } from "./BtnChooseAppDim.vue?vue&type=template&id=39355350&"
import script from "./BtnChooseAppDim.vue?vue&type=script&lang=js&"
export * from "./BtnChooseAppDim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports